import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {AppConfigService} from '../common/service/app-config.service';

@Injectable({
    providedIn: 'root'
})
export class NlrpLodgeFieldRecordService {
    private planTypes = new BehaviorSubject<[]>([]);
    private attachmentTypes = new BehaviorSubject<[]>([]);

    constructor(private http: HttpClient, private appConfigService: AppConfigService) {}

    updatePlanTypes(newdata: []) {
        this.planTypes.next(newdata);
    }

    getPlanTypes(): Observable<[]> {
        return this.planTypes;
    }

    updateAttachmentTypes(newdata: []) {
        this.attachmentTypes.next(newdata);
    }

    getAttachmentTypes(): Observable<[]> {
        return this.attachmentTypes;
    }

    save(fieldRecordLodgementViewModel: any): Observable<any> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/fieldrecord/lodgement/save';
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })
        return this.http.post<any>(url, JSON.stringify(fieldRecordLodgementViewModel), {headers});
    }
}
